module.exports = __webpack_public_path__ + "static/media/student_icon_selected.c965ec34.svg";